import * as React from 'react';
import '../css/SuperUserPageView.css';

import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import {IProduct} from "../../../infrastructure/interfaces";
import disclaimersImage from '../img/disclaimersImage.png';
import taglinesImage from '../img/taglinesImage.png';


const mapStateToProps = (state: any) => {
	return {
	};
};
export interface IManageTextProps {
	products: [IProduct];
}

export interface IManageTextState {
	previewingProduct: IProduct | null;
	productsFilter: string;
	typesFilter: string;
	categoryFilter: string;
	publishedFilter: string;
	categories:string[];
}

@(connect(mapStateToProps) as any)
export default class ManageTextTable extends React.Component<IManageTextProps, IManageTextState> {
  tableRow: HTMLElement;

  render() {
	return (
	  <div className="inner-su-container">
		<div className="manage-single-item-row">
		  <div className="in-row-text-container">
			Manage Text
		  </div>
		</div>

		<table className="table-scrollableSU images-table">
		  <tbody className="table-scrollable-body">
			  <tr>
				<td className="imageMainTableCell">
				  <Route
					  render={({ history }) => {
						return (
							<button onClick={() => history.push('/ManageTaglines')} title="Manage Taglines">
							  <div><b>Manage Taglines</b></div>
							  <img className="imageMainTableImage" src={taglinesImage} />
						  </button>
						);
					  }}
					/>
			  </td>
			  	<td className="imageMainTableCell">
					<Route
						render={({ history }) => {
					  	return (
						  	<button onClick={() => history.push('/ManageDisclaimers')} title="Manage Disclaimers">
								<div><b>Manage Disclaimers</b></div>
								<img className="imageMainTableImage" src={disclaimersImage} />
							</button>
					  	);
						}}
				  	/>
				</td>
			  </tr>
			 </tbody>
		</table>
	  </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageText.tsx